import React from 'react';
import { i18n } from 'config/locales';
import { CitizenshipForeignPassportsTravelModel } from 'forms/sections/citizenship/foreignPassports/types';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import Field from 'components/Form/Field';
import Country from 'components/Form/Country';
import DateRange from 'components/Form/DateRange';
import { setAttribute } from '../../../Form/shared/setAttribute';

interface Props extends ValidationElementProps, CitizenshipForeignPassportsTravelModel {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
}
export default class TravelItem extends ValidationElement<Props> {
  constructor(props) {
    super(props);
    this.updateCountryFocused = this.updateCountryFocused.bind(this);
  };

  update = (queue: Partial<CitizenshipForeignPassportsTravelModel>) => {
    this.props.onUpdate({
      Country: this.props.Country,
      Dates: this.props.Dates,
      CountryFocused: this.props.CountryFocused,
      ...queue,
    });
  };

  updateCountry = (values: CitizenshipForeignPassportsTravelModel['Country']) => {
    this.update({
      Country: values,
    });
  };

  updateDates = (values: CitizenshipForeignPassportsTravelModel['Dates']) => {
    this.update({
      Dates: values,
    });
  };

  updateCountryFocused(focus: boolean) {
    this.update({
      CountryFocused: focus,
    });
  };

  render() {
    const attribute = setAttribute(this.props.attribute, `items[${this.props.$index}].Item`);
    return (
      <div className="citizenship-item">
        <Field
          title={i18n.t('citizenship.multiple.heading.travel.country')}
          scrollIntoView={this.props.scrollIntoView}
          attribute={`${attribute}.Country`}
        >
          <Country
            attribute={`${attribute}.Country`}
            name="Country"
            className="travel-item-country"
            {...this.props.Country}
            updateCountryFocused={this.updateCountryFocused}
            onUpdate={this.updateCountry}
            onError={this.props.onError}
            required={this.props.required}
          />
        </Field>

        <Field
          title={i18n.t('citizenship.multiple.heading.travel.dates')}
          help="citizenship.multiple.help.travel.dates"
          adjustFor="daterange"
          scrollIntoView={this.props.scrollIntoView}
          attribute={`${attribute}.Dates`}
        >
          <DateRange
            attribute={`${attribute}.Dates`}
            name="Dates"
            className="travel-item-dates"
            {...this.props.Dates}
            minDateEqualTo
            onUpdate={this.updateDates}
            onError={this.props.onError}
            required={this.props.required}
            hideFromDay
            hideToDay
          />
        </Field>
      </div>
    );
  }
}

TravelItem.defaultProps = {
  Country: {},
  Dates: {},
  CountryFocused: false,
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
};
